module.exports = __webpack_public_path__ + "static/media/guide_img1_5_m.29fdf7fe.png";